<template>
  <div>
    <div class="add_goods_cont">
      <div class="cont_left">
        <div class="cont_left_text">
          <i class="iconfont icon-icon_favorite" style="font-size:18px"></i> 选择分类
          <div class="cont_left_icon"></div>
        </div>
      </div>
      <div class="cont_right">
        <el-form ref="form" :model="form" label-width="200px">
          <el-form-item></el-form-item>

          <el-form-item label="商品分类">{{form.top_class}}>{{form.third_class}}>{{form.second_class}}</el-form-item>

          <el-form-item label="商品名称">
            <el-input style="width:50%" :disabled="form.check == 1? true : false" v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="常用名称">
            <el-input style="width:50%" v-model="form.common_title"></el-input>
          </el-form-item>
          <el-form-item label="品牌">
            <el-input style="width:50%" :disabled="form.check == 1? true : false" v-model="form.brand"></el-input>
          </el-form-item>
          <el-form-item label="货号">
            <el-input style="width:50%" :disabled="form.check == 1? true : false" v-model="form.item_no"></el-input>
          </el-form-item>
          <el-form-item label="货期">
            <el-input style="width:50%" v-model="form.leadtime"></el-input>
          </el-form-item>
          <el-form-item label="规格">
            <el-input style="width:50%" v-model="form.specification"></el-input>
          </el-form-item>
          <el-form-item label="型号">
            <el-input style="width:50%" v-model="form.model"></el-input>
          </el-form-item>
          <el-form-item label="应用">
            <el-input style="width:50%" v-model="form.uses"></el-input>
          </el-form-item>
          <el-form-item label="库存">
            <el-input style="width:50%" v-model="form.inventory"></el-input>
          </el-form-item>
          <el-form-item label="售价">
            <el-input style="width:50%" v-model="form.selling_price"></el-input>
          </el-form-item>
          <el-form-item label="原价">
            <el-input style="width:50%" v-model="form.original_price"></el-input>
          </el-form-item>

          <!-- <el-form-item label="说明文档">
            <el-upload
              class="upload-demo"
              :on-change="changeDoc"
              :auto-upload="false"
              :limit="1"
              action
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传pdf/word/wps文件,且不超过500kb</div>
            </el-upload>
          </el-form-item> -->

          <el-form-item label="图片">
            <div class="updataimg">
              <img
                v-if="imgshow"
                width="146px"
                height="146px"
                style="border-radius: 6px;margin-right:8px"
                :src=" url + form.images"
                alt
              />
              <el-upload
                list-type="picture-card"
                :on-change="changeImg"
                :auto-upload="false"
                :limit="1"
                action
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>

            <!-- <el-dialog>
              <img width="100%" alt />
            </el-dialog>-->
          </el-form-item>
          <el-form-item label="详情">
            <div id="editor1">
              <wangeditor :info="form.info" @change_edit1="change_edit1" />
              <!-- :info="form.info" -->
            </div>
          </el-form-item>

          <el-form-item>
            <div style="margin: 20px auto 20px auto;width:100px">
              <el-button :loading="btnloding" @click="submit" type="primary">确定上传</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import wangeditor from "../../components/wangeditor";
export default {
  components: {
    wangeditor
  },
  data() {
    return {
      url: this.$store.state.serve,
      btnloding: false,
      form: {},
      doc: null,
      image: null,
      info: null,
      token: this.$cookies.get("shop_token"),
      id: this.$route.query.id,
      imgshow: true
    };
  },
  created() {
    this.axios
      .get(this.$store.state.serve + "shop/show_product", {
        params: {
          id: this.id,
          token: this.token
        }
      })
      .then(res => {
        if (res.data.status == "success") {
          this.form = res.data.data;
        }
      });
  },
  mounted() {},
  methods: {
    changeDoc(file) {
      this.doc = file.raw;
    },
    changeImg(file) {
      this.imgshow = false;
      this.image = file.raw;
    },
    submit() {
      this.btnloding = true;
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      const formData = new FormData();
      if (this.form.title != "") {
        formData.append("title", this.form.title);
      }
      if (this.form.common_title != "") {
        formData.append("common_title", this.form.common_title);
      }

      if (this.form.top_class != "") {
        formData.append("top_class", this.form.top_class);
      }
      if (this.form.third_class != "") {
        formData.append("third_class", this.form.third_class);
      }
      if (this.form.second_class != "") {
        formData.append("second_class", this.form.second_class);
      }

      if (this.form.brand != "") {
        formData.append("brand", this.form.brand);
      }
      if (this.form.item_no != "") {
        formData.append("item_no", this.form.item_no);
      }
      if (this.form.leadtime != "") {
        formData.append("leadtime", this.form.leadtime);
      }
      if (this.form.specification != "") {
        formData.append("specification", this.form.specification);
      }
      if (this.form.model != "") {
        formData.append("model", this.form.model);
      }
      if (this.form.uses != "") {
        formData.append("uses", this.form.uses);
      }
      if (this.form.inventory != "") {
        formData.append("inventory", this.form.inventory);
      }
      if (this.form.selling_price != "") {
        formData.append("selling_price", this.form.selling_price);
      }
      if (this.form.original_price != "") {
        formData.append("original_price", this.form.original_price);
      }

      if (this.info != null) {
        //info发生了改变
        formData.append("info", this.info);
      } else {
        //未发生改变
        formData.append("info", this.form.info);
      }

      if (this.doc != null) {
        formData.append("doc", this.doc);
      }

      if (this.image != null) {
        formData.append("image", this.image);
      }

      formData.append("token", this.token);
      formData.append("id", this.id);
      this.axios
        .post(this.$store.state.serve + "shop/edit_product", formData, config)
        .then(res => {
          if (res.data.status == "success") {
            this.btnloding = false;
            this.$alerts.success("上传成功", this.$message);
            this.$router.push("/shop/goodslist");
          } else if (res.data.status == "error") {
            this.$alerts.error(res.data.msg, this.$message);
          }
        });
    },
    change_edit1(data) {
      this.info = data;
    }
  }
};
</script>
<style lang='scss'>
.add_godds_top {
  width: 500px;
  margin: 0 auto;
  .ve-toolbar {
    display: flex;
    align-items: center;
  }
  .is-text {
    width: 54px;
    height: 54px;
  }
  .el-step__line {
    position: absolute !important;
    top: 26px !important;
  }
}
.add_goods_cont {
  margin-top: 33px;
  width: 100%;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  margin-bottom: 86px;
  display: flex;
  .cont_left {
    width: 182px;
    //  height: 100%;
    background: rgba(238, 238, 238, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
    position: relative;
    .cont_left_text {
      width: 100%;
      height: 54px;
      background: rgba(166, 182, 193, 1);
      position: absolute;
      left: 0;
      top: 80px;
      font-size: 18px;
      font-family: "Microsoft YaHei";
      text-align: center;
      line-height: 54px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      .cont_left_icon {
        width: 0;
        height: 0;
        border-left: 39px solid #a6b6c1;
        border-bottom: 39px solid transparent;
        transform: rotate(135deg);
        position: absolute;
        right: -19px;
        top: 8px;
      }
    }
  }
  .cont_right {
    width: 80%;
    height: 100%;
    .updataimg {
      display: flex;
    }
  }
}
</style>